<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', ncm)">
      <v-card v-if="ncm" :loading="salvando">
        <v-card-title> {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} NCM </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="ncm.descricao"
                    label="Descrição"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="ncm.codigo"
                    label="Codigo"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-menu
                    v-model="menuDataInicio"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataInicioFormatada"
                        v-mask="['##/##/####']"
                        label="Inicio"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        @blur="dataInicio = parseDate(dataInicioFormatada)"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="dataInicio" @input="menuDataInicio = false" />
                  </v-menu>
                </v-col>
                <v-col>
                  <v-menu
                    v-model="menuDataFim"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataFimFormatada"
                        v-mask="['##/##/####']"
                        label="Fim"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        @blur="dataFim = parseDate(dataFimFormatada)"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="dataFim" @input="menuDataFim = false" />
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(ncm)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import NCM from '../../models/ncm'
import NCMService from '../../services/ncm/ncm'
import { obrigatorio } from '../../shareds/regrasForm'
import { formatDate, parseDate } from '@/shareds/formatacoes'
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },

  props: ['showDialog', 'ncmParam', 'operacao', 'itens'],

  data: () => ({
    dialog: false,
    ncm: new NCM(),
    obrigatorio: obrigatorio,
    formatDate: formatDate,
    parseDate: parseDate,
    salvando: false,
    validForm: false,
    dataError: '',
    showMessageError: false,
    menuDataInicio: false,
    menuDataFim: false,
    dataInicio: '',
    dataFim: '',
    dataInicioFormatada: '',
    dataFimFormatada: ''
  }),
  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    ncmParam() {
      return this.ncmParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    },
    dataInicio() {
      if (this.dataInicio !== undefined) this.dataInicioFormatada = this.formatDate(this.dataInicio)
    },
    dataFim() {
      if (this.dataFim !== undefined) this.dataFimFormatada = this.formatDate(this.dataFim)
    }
  },
  methods: {
    initialize() {
      this.dataInicio = null
      this.dataFim = null
      this.dataInicioFormatada = null
      this.dataFimFormatada = null
      this.ncm = new NCM()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.ncm = this.ncmParam
      this.dataInicio = this.ncm.dataInicio
      this.dataFim = this.ncm.dataFim
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false

      try {
        const data = {
          ...item,
          dataInicio: this.dataInicio,
          dataFim: this.dataFim
        }

        const ncmSalva =
          this.operacao === 'adicionar'
            ? await NCMService.create({ ...data })
            : await NCMService.update(data.id, data)

        this.$emit('confirmado', ncmSalva)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
